import { useContext, type Context, type Dispatch } from "react";

export const useDispatchContext = <T>(
	context: Context<Dispatch<T> | undefined>,
): Dispatch<T> => {
	const dispatch = useContext(context);
	if (!dispatch) {
		throw new Error("useDispatchContext must be used within a Provider");
	}
	return dispatch;
};
